module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-3.c1a11a4e.jpg";